import React, { useEffect, useState } from 'react'
import { List } from './Components/List'
import { Accordions } from './Components/Accordions'
import { Button } from './Components/Button'
import { Breadcrumbs } from './Components/Breadcrumbs'
import { useTranslation } from 'utils/useTranslation'
import { useSingleProductInformation } from 'utils/useSingleProductInformation'
import { accessoryStorageGet, accessoryStorageSet } from "app/React/Helpers/AccessoryStorageHelper";

export default function SingleProduct({ accessory }) {
  const [cartItems, setCartItems] = useState(accessoryStorageGet('cart-items') ?? [])
  const accessoryStrings = useTranslation('accessories_shop.misc') ?? {}
  const breadcrumbs = useSingleProductInformation('breadcrumbs') ?? {}
  const isInCart = cartItems.find((item) => item.id === accessory.id)

  const onAddToCartClick = (e) => {
    e.preventDefault()

    let tempCartItems = {}
    if (isInCart) {
      tempCartItems = cartItems.filter((item) => item.id !== accessory.id)
    } else {
      tempCartItems = [...cartItems, accessory]
    }

    accessoryStorageSet('cart-items', tempCartItems)
    setCartItems(tempCartItems)
  }

  useEffect(() => {
    const storageListener = () => {
      setCartItems(accessoryStorageGet('cart-items') ?? [])
    }

    window.addEventListener('storage', storageListener, false)
    return () => {
      window.removeEventListener('storage', storageListener, false)
    }
  }, [])

  return (
    <div className='page_container'>
      <div className='mtt-product-card-big'>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        <div className='mtt-product-card-big__content-wrapper'>
          <div className='mtt-product-card-big__image-wrapper'>
            <img src={accessory.image} alt='' />
          </div>

          <div className='mtt-product-card-big__text-wrapper'>
            <h1 className='mtt-title'>{accessory.title}</h1>

            <div className='mtt-terms'>{accessory.short_models_name.join(', ')}</div>
            <div className='mtt-price'>{accessory.price.formatted}</div>
            <div className='mtt-tagline'>{accessoryStrings.incl_vat}</div>

            <div className='mtt-excerpt wysiwyg' dangerouslySetInnerHTML={{ __html: accessory.description }} />

            <div className='list-title'>{accessory.features_title}</div>
            <List items={accessory.features} showAll />
            <div className='mtt-label' dangerouslySetInnerHTML={{ __html: accessory.obligation_text }} />
            <Button
              classes='primary'
              text={isInCart ? accessoryStrings.remove_from_cart : accessoryStrings.add_to_cart}
              onClick={onAddToCartClick}
            />
            <Accordions specifications={accessory.specifications} fits={accessory.fits} />
          </div>
        </div>
      </div>
    </div>
  )
}
